import { render, staticRenderFns } from "./PhotoShooterMob.vue?vue&type=template&id=bcb81654&scoped=true&"
import script from "./PhotoShooterMob.vue?vue&type=script&lang=js&"
export * from "./PhotoShooterMob.vue?vue&type=script&lang=js&"
import style0 from "./PhotoShooterMob.vue?vue&type=style&index=0&id=bcb81654&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb81654",
  null
  
)

export default component.exports